import Button from '@components/atoms/button'

type Props = {
  handleBecomeTeacher: () => void
}

const HowTeachingWorks = ({ handleBecomeTeacher }: Props) => {
  return (
    <div className="py-12 lg:py-16 px-5 text-grey">
      <div className="max-w-5xl mx-auto flex flex-col items-center">
        <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
          How teaching works at Codingal
        </h2>
        <p className="font-400 text-lg md:text-xl text-center max-w-4xl">
          Learn who can teach, what you can teach, how classes run, when you
          schedule them, and how you get paid.
        </p>
        <div className="flex-1 w-full max-w-2xl flex-shrink-0 mt-3">
          <iframe
            src="https://iframe.mediadelivery.net/embed/239253/5c9a16b0-03d4-4773-a4ef-756a6470a45b?autoplay=false&loop=true&muted=false&preload=false&responsive=true"
            className="w-full h-96 rounded-xl border-none bg-black"
            allow="accelerometer;gyroscope;encrypted-media;picture-in-picture;"
            allowFullScreen
          />
        </div>
        <p className="mt-6 text-lg text-grey-900 text-center">
          See how easy it is to start teaching and earning with Codingal.
        </p>
        <div className="self-stretch flex justify-center mt-6">
          <Button
            variant="solid"
            intent="primary"
            size="lg"
            onClick={handleBecomeTeacher}
            className="w-full sm:w-auto"
          >
            Become a teacher
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HowTeachingWorks
